import { useSelector } from 'react-redux';

export const useItemsInMarket = () => {
  const { market } = useSelector((state) => state.markets);
  const { cuisines } = useSelector((state) => state);

  const venuesInMarket = market.venues.items;

  const cuisinesList = cuisines.list?.reduce((list, cuisine) => {
    if (
      venuesInMarket.some((venue) =>
        venue.cuisines?.items.some((item) => item.cuisine.id === cuisine.id)
      )
    ) {
      list.push(cuisine);
    }

    return list;
  }, []);

  const sortList = (list) => list.sort((a, b) => a.name.localeCompare(b.name));

  return {
    venues: sortList(venuesInMarket),
    cuisines: sortList(cuisinesList),
  };
};
